export enum TimesheetFeatures {
  BANK_OF_HOURS = 'dev_time_tracking_bank_of_hours',
  COMPENSATION_FLOW_V2 = 'dev_time_tracking_compensation_flow_v2',
  BANK_OF_HOURS_TRANSFER_FREQUENCY = 'dev_time_tracking_bank_of_hours_transfer_frequency',
  EXTRA_HOUR_RULES = 'dev_time_tracking_extra_hour_rules',
  BANK_OF_HOURS_V2 = 'dev_time_tracking_bank_of_hours_v2',
  FORFAIT_JOUR = 'dev_forfaitjour_in_time_management',
  MATERIALIZED_DATA = 'dev_time_tracking_materialized_data',
  PAID_BREAKS = 'time_tracking_paid_breaks',
  PAYROLL = 'payroll_bundle',
  SPECIAL_HOURS = 'dev_time_tracking_majoration',
  GEOFENCING_BLOCK = 'dev_time_tracking_geofencing_block',
  ALERTS = 'dev_time_tracking_inconsistencies',
  LIMIT_BALANCE_POOL = 'time_tracking_limit_balance_pool',
  CORRECTIVE_BREAKS = 'time_tracking_corrective_breaks',
  CONTRACT_HOURS_BASELINE = 'time_tracking_contract_hours_baseline',
  DEV_CONTRACT_HOURS_BASELINE = 'dev_time_tracking_contract_hours_baseline',
  MATERIALIZED_WORKED_TIME_CLICKHOUSE = 'dev_time_tracking_clickhouse_analytics',
  MATERIALIZED_BALANCE_DATA = 'dev_time_tracking_materialized_balance_data',
}
